import {
  messages as printPackingSlipMessages,
  hotkey as printPackingSlipHotkey,
  barcodeContent as printPackingSlipBarcode,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/print-packing-slip';
import {
  messages as printPickListMessages,
  hotkey as printPickListHotkey,
  barcodeContent as printPickSlipBarcode,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/print-pick-list';
import {
  messages as printOrderSummaryMessages,
  hotkey as printOrderSummaryHotkey,
  barcodeContent as printOrderSummaryBarcode,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/print-order-summary';

export default [
  {
    barcodeContent: printPackingSlipBarcode,
    intlFormattedName: printPackingSlipMessages.name,
    hotkey: printPackingSlipHotkey,
  },
  {
    barcodeContent: printPickSlipBarcode,
    intlFormattedName: printPickListMessages.name,
    hotkey: printPickListHotkey,
  },
  {
    barcodeContent: printOrderSummaryBarcode,
    intlFormattedName: printOrderSummaryMessages.name,
    hotkey: printOrderSummaryHotkey,
  },
];
